import Typography from "@mui/material/Typography";
import { styled as muiStyled } from "@mui/material/styles";

export const HeaderContainer = muiStyled("header")(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    //borderBottom: `1px solid ${theme.palette.grey[300]}`,
    //backgroundColor: theme.palette.surfaceContainerLowest,
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(2, 0),
}));

export const HeaderContent = muiStyled("div")(({ theme }) => ({
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 2.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(0, 5),
    },
}));

export const HeaderLogoutWrapper = muiStyled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
}));

export const SidebarContainer = muiStyled("nav")(({ theme }) => ({
    position: "relative",
    //borderRight: `1px solid ${theme.palette.outline}`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: theme.palette.surfaceContainerLowest,
    transition: theme.transitions.create("width", {
        duration: theme.transitions.duration.standard,
    }),
    height: "100vh",
    "& a": {
        textDecoration: "none",
        color: theme.palette.text.secondary,
    },
}));

export const SidebarLogo = muiStyled("img", {
    shouldForwardProp: (prop) => prop !== 'mini',
})<{
    mini?: boolean;
}>(({ theme, mini }) => ({
    height: theme.spacing(5),
    width: "auto",
    filter: 'brightness(0) invert(1)',
    transition: theme.transitions.create(['width', 'height'], {
        duration: theme.transitions.duration.shorter,
    }),
    objectFit: 'contain',
}));

export const SidebarLogoWrapper = muiStyled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2.5),
    },
    //borderBottom: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.primary.main,
}));

export const SidebarList = muiStyled("ul")(({ theme }) => ({
    listStyle: "none",
    padding: theme.spacing(1.75, 1.25),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    margin: 0,
    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(2.5, 2),
    },
}));

export const SidebarItem = muiStyled('div', {
    shouldForwardProp: (prop) =>
        prop !== 'showMenu' && prop !== 'selected' && prop !== 'onlyIcon' && prop !== 'defaultColor',
})<{
    selected?: boolean;
    showMenu?: boolean;
    onlyIcon?: boolean;
    defaultColor?: string;
}>(({ theme, selected, showMenu, onlyIcon, defaultColor }) => {
    const resolvedColor = selected
        ? theme.palette.primary.main
        : defaultColor ?? theme.palette.text.secondary;

    return {
        padding: onlyIcon ? theme.spacing(1.25) : theme.spacing(1, 1.5),
        borderRadius: 10,
        transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.shorter,
        }),
        display: 'flex',
        alignItems: 'center',
        justifyContent: showMenu ? 'flex-start' : 'center',
        gap: showMenu ? theme.spacing(1.25) : 0,
        cursor: 'pointer',
        color: resolvedColor,
        backgroundColor: selected ? theme.palette.primary.light : 'transparent',
        [theme.breakpoints.up('md')]: {
            padding: onlyIcon ? theme.spacing(1.5) : theme.spacing(1.25, 1.75),
        },
        '& svg': {
            width: 20,
            height: 20,
            color: resolvedColor,
            [theme.breakpoints.up('md')]: {
                width: 24,
                height: 24,
            },
        },
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.secondary.main,
            '& svg': {
                color: theme.palette.secondary.main,
            },
        },
    };
});

export const SidebarLabel = muiStyled(Typography, {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'visible',
})<{
    selected?: boolean;
    visible?: boolean;
}>(({ theme, selected, visible }) => ({
    margin: 0,
    display: visible ? 'flex' : 'none',
    alignItems: 'center',
    color: 'inherit',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    lineHeight: 1.2,
    ...theme.typography.subtitle2,
    fontWeight: selected ? 600 : 500,
    letterSpacing: theme.typography.body2?.letterSpacing ?? '0.01em',
}));
